export default __webpack_public_path__ + "static/media/english-to-hungarian-screenshot-02.8654fe7c.png";